var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveillanceLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M12.867 23.078v1.425c0 .534-.27 1.12-.695 1.47m8.714.045c-.458-.343-.753-.957-.753-1.515V23.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M27.264 26.864l-5.523-1.011a.747.747 0 0 0-.577.132L16.5 29.422l-4.664-3.437a.747.747 0 0 0-.577-.133l-5.523 1.012c-2.779.807-4.686 3.321-4.686 6.177v6.528c0 .747.614 1.353 1.372 1.353h28.156c.758 0 1.372-.606 1.372-1.353v-6.528c0-2.856-1.907-5.37-4.686-6.177z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.675 26.143l3.023 4.17a.843.843 0 0 0 1.006.28l2.796-1.171-4.664-3.437a.747.747 0 0 0-.577-.133l-1.584.29zM23.325 26.143l-3.023 4.17a.843.843 0 0 1-1.006.28L16.5 29.422l4.664-3.437a.747.747 0 0 1 .577-.133l1.584.29z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M24.717 9.758c1.497-.66 2.395-1.52 2.395-2.501C27.112 4.997 22.36 1 16.5 1 10.64 1 5.888 4.998 5.888 7.257c0 .98.896 1.84 2.389 2.498M9.031 13.795c-.787-.134-1.405.336-1.405 1.036v1.404c0 .7.576 1.268 1.286 1.268h.486c.04 1.84.825 3.61 2.241 4.813 1.14.968 2.743 1.813 4.86 1.837 2.118-.024 3.721-.869 4.862-1.837 1.416-1.203 2.2-2.973 2.24-4.813h.487c.71 0 1.285-.568 1.285-1.268v-1.404c0-.7-.326-1.105-1.036-1.105"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M8.32 9.341v4.365s1.086-.024 1.784.657a.232.232 0 0 0 .393-.164v-2.314m12.006 0v2.314c0 .202.247.306.393.164.698-.681 1.785-.657 1.785-.657V9.889"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M24.68 9.809c0 1.705-3.662 3.088-8.18 3.088s-8.18-1.383-8.18-3.088"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M24.68 9.809V7.687c0-.575-.395-1.077-.96-1.22-1.514-.38-4.593-1.048-7.603-1.05-2.774 0-5.489.654-6.866 1.036a1.261 1.261 0 0 0-.932 1.212v2.144"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 29.422l-2.199.92 1.286 1.474h1.826l1.286-1.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.413 31.816h-1.826L14.3 40.922H18.7z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.534 37.887H8.315a.385.385 0 0 1-.387-.382v-1.69c0-.211.173-.382.387-.382h3.219c.214 0 .387.17.387.382v1.69c0 .211-.173.382-.387.382zM24.535 37.918h-3.22a.385.385 0 0 1-.386-.381v-1.691c0-.211.173-.382.387-.382h3.219c.213 0 .387.17.387.382v1.69c0 .211-.174.382-.387.382z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#C2C2C2",
    strokeLinejoin: "round",
    strokeWidth: 0.782,
    d: "M2.292 30.854c.603.48 1.487.387 1.974-.208l.665-.814a1.371 1.371 0 0 0-.212-1.946l-.477-.38a6.479 6.479 0 0 0-2.591 2.839l.64.51zM31.35 30.345a6.478 6.478 0 0 0-2.592-2.838l-.477.379a1.371 1.371 0 0 0-.212 1.946l.665.814c.487.595 1.37.688 1.974.208l.641-.51z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C2C2C2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.911 35.049v5.873h.79v-5.873a.395.395 0 1 0-.79 0zM5.112 35.08v5.873h.791V35.08a.395.395 0 1 0-.79 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveillanceLine);
export default __webpack_public_path__ + "static/media/surveillance_line.d360aeb5dee664059955ea3b71ac08e0.svg";
export { ForwardRef as ReactComponent };